import ProfileNavbar from "./profile-navbar/profileNavbar";
import { useState } from "react";
import "./dashboard.css";
import { Routes, Route } from "react-router-dom";
import UploadImage from "./image-display/uploadImage";
import Guidelines from "./guidelines/guidelines";

export default function Dashboard() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div className='dashboard'>
      <ProfileNavbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <Routes>
        <Route path='upload' element={<UploadImage />} />
      </Routes>
      <Routes>
        <Route path='guidelines' element={<Guidelines />} />
      </Routes>
    </div>
  );
}
